import { render, staticRenderFns } from "./DialogList.vue?vue&type=template&id=c2f073d2&scoped=true&"
import script from "./DialogList.vue?vue&type=script&lang=js&"
export * from "./DialogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f073d2",
  null
  
)

export default component.exports